export default __webpack_public_path__ + "static/media/logo-info-entreprises.a71d7f80.svg";